import api from './api';

export async function authenticate(userData) {
  return await api.post('/v1/token', userData);
}

export function resetPassword(userData) {
  return api.post('/v1/reset_password', userData);
}

export function verifyEmail(userData) {
  return api.post('/v1/verify_email', userData);
}

export async function logoutUser() {
  return await api.post('/v1/logout', {});
}

///////////////////////////////////////////////
//// BRANDS
///////////////////////////////////////////////

export async function getBrands() {
  return await api.get('/v1/brands');
}

export async function updateBrand(id, data) {
  return await api.patch(`/v1/brand/${id}`, data);
}

export async function createBrand(data) {
  return await api.post('/v1/brand', data);
}

export async function deleteBrand(id) {
  return await api.delete(`/v1/brand/${id}`);
}

///////////////////////////////////////////////
//// USERS
///////////////////////////////////////////////

export async function getUsers(params) {
  const payload = {
    params: params
  };
  return await api.get('/v1/manage_users', payload);
}

export async function getContentUsers() {
  return await api.get('/v1/content_users');
}

export async function createUser(params) {
  return await api.post('/v1/manage_user', params);
}

export async function verifyUser(id, params) {
  return await api.patch(`/v1/manage_user/${id}`, params);
}

export async function banUser(id, params) {
  return await api.patch(`/v1/manage_user/${id}`, params);
}

export async function restrictUser(id, params) {
  return await api.patch(`/v1/manage_user/${id}`, params);
}

export async function toggleIgnoreProCount(id, params) {
  return await api.patch(`/v1/manage_user/${id}`, params);
}

export async function resetUsersPassword(email) {
  const params = {
    email
  };
  return await api.post(`/v1/forgot_password`, params);
}

export async function deleteUser(id) {
  return await api.post(`/v1/manage_delete_user/${id}`);
}

export async function grantPro(id, params) {
  return await api.post(`/v1/grant_promotion/${id}`, params);
}

///////////////////////////////////////////////
//// EXERCISES
///////////////////////////////////////////////

export async function getExercises(params) {
  const payload = {
    params: params
  };
  return await api.get('/v1/exercises', payload);
}

export async function loadVideos(id) {
  return await api.get(`/v1/exercise_videos/${id}`);
}

export async function getContentExercises(params) {
  const payload = {
    params: params
  };
  return await api.get('/v1/manage_exercises', payload);
}

export async function createExercise(data) {
  return await api.post('/v1/manage_exercise', data);
}

export async function updateExercise(id, data) {
  return await api.patch(`/v1/manage_exercise/${id}`, data);
}

export async function updateExerciseVideos(id, data) {
  return await api.patch(`/v1/manage_exercise_videos/${id}`, data);
}

export async function deleteExercise(id) {
  return await api.delete(`/v1/manage_exercise/${id}`);
}

export async function getFilters() {
  return await api.get('/v1/exercise_filters');
}

///////////////////////////////////////////////
//// FEEDBACK
///////////////////////////////////////////////

export async function getFeedback(payload) {
  return await api.get('/v1/feedback', { params: payload});
}

export async function updatedFeedback(id, payload) {
  return await api.patch(`/v1/feedback/${id}`, payload);
}

///////////////////////////////////////////////
//// WORKOUTS
///////////////////////////////////////////////

export async function getPublicWorkouts(params) {
  return await api.get('/v2/manage_public_workouts', {params: params});
}

export async function getPublicWorkoutDetails(id) {
  return await api.get(`/v2/workout/${id}`);
}

export async function getPlaceholderImages() {
  return await api.get('/v1/official_placeholder_images');
}

export async function createWorkout(data) {
  return await api.post(`/v1/official_workout`, data);
}

export async function updateWorkout(id, data) {
  return await api.patch(`/v1/official_workout/${id}`, data);
}

export async function deleteWorkout(id, data) {
  return await api.delete(`/v1/official_workout/${id}`);
}

export async function saveExerciseAndReps(id, data) {
  return await api.post(`/v1/official_workout_exercise/${id}`, data);
}

export async function saveWorkoutPlaceholderImages(data) {
  return await api.post(`/v1/official_placeholder_images`, data);
}

export async function createActivity(params) {
  return await api.post('/v1/manage_activity', params);
}

export async function createPost(params) {
  return await api.post('/v1/manage_post', params);
}

///////////////////////////////////////////////
//// REPORTS
///////////////////////////////////////////////

export async function getUserReportDetails(id) {
  return await api.get(`/v1/manage_reports/${id}`);
}

export async function resolveReport(id, params) {
  return await api.post(`/v1/manage_report/${id}`, params);
}

export async function loadReportedActivity(id) {
  return await api.get(`/v1/reported_activity/${id}`);
}

export async function loadReportedGroup(id) {
  return await api.get(`/v1/reported_group/${id}`);
}

export async function loadReportedUser(id) {
  return await api.get(`/v1/reported_user/${id}`);
}

export async function loadReportedComment(id) {
  return await api.get(`/v1/reported_comment/${id}`);
}

export async function loadReportedMessage(id) {
  return await api.get(`/v1/reported_message/${id}`);
}

///////////////////////////////////////////////
//// DOCUMENTS
///////////////////////////////////////////////

export async function getDocuments() {
  return await api.get('/v1/manage_official_documents');
}

export async function getDocumentDetails(type) {
  return await api.get(`/v1/manage_official_document/${type}`);
}

export async function getViewDocumentDetails(type) {
  let payload = { type };
  return await api.get(`/v1/documents`, { params: payload });
}

export async function saveSection(id, payload) {
  return await api.patch(`/v1/manage_official_document/${id}`, payload);
}

export async function createSection(payload) {
  return await api.post(`/v1/manage_official_document`, payload);
}

export async function deleteSection(id) {
  return await api.delete(`/v1/manage_official_document/${id}`);
}

///////////////////////////////////////////////
//// STATISTICS
///////////////////////////////////////////////

export async function getDateStats(date) {
  return await api.get(`/v1/date_stats`, { params: { date: date }});
}

export async function getStaticStats() {
  return await api.get(`/v1/stats`);
}

///////////////////////////////////////////////
//// CAMPAIGNS & ADVERTS
///////////////////////////////////////////////

export async function getCampaigns(params) {
  return await api.get(`/v1/campaigns`, { params });
}

export async function createAdvert(payload) {
  return await api.post(`/v1/advert`, payload);
}

export async function updateAdvert(id, payload) {
  return await api.patch(`/v1/advert/${id}`, payload);
}

export async function createCampaign(payload) {
  return await api.post(`/v1/campaign`, payload);
}

export async function updateCampaign(id, payload) {
  return await api.patch(`/v1/campaign/${id}`, payload);
}

export async function deleteAdvert(id) {
  return await api.delete(`/v1/advert/${id}`);
}

///////////////////////////////////////////////
//// CHALLENGES
///////////////////////////////////////////////

export async function awardBadge(id, params) {
  return await api.post(`/v2/challenge/${id}/award`, params);
}

export async function createChallenge(data) {
  return await api.post('/v2/challenge', data);
}

export async function updateChallenge(id, data) {
  return await api.patch(`/v2/challenge/${id}`, data);
}

export async function getParentChallenge(id) {
  return await api.get(`/v2/parent_challenge/${id}`);
}

///////////////////////////////////////////////
//// SETTINGS
///////////////////////////////////////////////

export async function getSettings() {
  return await api.get(`/v1/settings`);
}

export async function saveSettingIntroVideo(data) {
  return await api.post(`/v1/intro_video`, data);
}

export async function saveSettingReview(data) {
  return await api.post(`/v1/setting`, data);
}

///////////////////////////////////////////////
//// BLOGS
///////////////////////////////////////////////

export async function createBlog(data) {
  return await api.post(`/v1/manage_blog`, data);
}

export async function editBlog(id, data) {
  return await api.patch(`/v1/manage_blog/${id}`, data);
}

export async function getBlogs() {
  return await api.get('/v1/manage_blogs');
}

export async function listBlogs(params) {
  return await api.get('/v1/blogs', { params });
}

export async function getBlogDetails(id) {
  return await api.get(`/v1/manage_blog/${id}`);
}

export async function getBlog(urlName) {
  return await api.get(`/v1/blog/${urlName}`);
}

export async function deleteBlog(id) {
  return await api.delete(`/v1/manage_blog/${id}`);
}

///////////////////////////////////////////////
//// ACCOUNT DELETION
///////////////////////////////////////////////

export async function requestAccountDelete(data) {
  return await api.post(`/v1/request_account_deletion`, data);
}

export async function deleteActualAccount(data) {
  return await api.post(`/v1/confirm_delete_account`, data);
}